export interface IStyleGridItem {
  area: string;
}

export enum HistoryTabs {
  QuickView = 'quickView',
  Details = 'details',
}
